export enum ProviderMediaType {
  Audio = 'audio',
  Video = 'video',
}

export enum ProviderRemoteStreamType {
  HighStream = 0,
  LowStream = 1,
}

export enum CallConnectionQuality {
  Excellent = 'excellent',
  Good = 'good',
  Poor = 'poor',
  Lost = 'lost',
  Unknown = 'unknown',
}
